import { useEffect } from 'react';
import { useQueryParam } from 'react-resource-router';

import { parseAtlOrigin, parseEmailSource, useAnalytics } from '@townsquare/analytics';
import { teamProfileRoute } from '@townsquare/ptc-directory-view';
import { useRouterActions } from '@townsquare/router/primitives';
import { createSearchParamsFromCurrentUrl } from '@townsquare/url-utils/search-params';

import { useRoute } from './router/hooks';

export const AnalyticAttributeHandler = () => {
  const analytics = useAnalytics();
  const { setQueryParams } = useRouterActions();
  const [atlOrigin] = useQueryParam('atlOrigin');
  const [src] = useQueryParam('src');
  const route = useRoute();

  useEffect(() => {
    const queryParams = createSearchParamsFromCurrentUrl();
    if (atlOrigin) {
      void analytics.setTopLevelAttributes({
        ...parseAtlOrigin(atlOrigin),
      });
      void analytics.getAnalyticsWebClient().sendOperationalEvent({
        actionSubject: 'origin',
        action: 'landed',
        source: 'team-central',
        attributes: {
          ...parseAtlOrigin(atlOrigin),
        },
      });
      queryParams.delete('atlOrigin');
    }

    if (src) {
      void analytics.setTopLevelAttributes({
        ...parseEmailSource(src),
      });
      void analytics.ui('src', 'landed', {
        route: route.path,
      });
      /**
       * https://product-fabric.atlassian.net/browse/PTC-6958
       * The directory component expects the src field, it handles removing the
       * URL search param.
       *  */
      if (route.name === teamProfileRoute.name) {
        return;
      }
      queryParams.delete('src');
    }

    setQueryParams(queryParams, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [analytics, setQueryParams]);

  return null;
};
